import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const UndrawCertificationSvg = () => (
  <svg
    width='1em'
    height='1.15em'
    viewBox='0 0 241 279'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M130.383 2H241V161.648C241 214.862 194.368 258 136.845 258H36.4921C16.3381 258 0 242.886 0 224.242V122.615C0 56.0014 58.3746 2 130.383 2ZM22.6806 130.848C29.6309 90.3842 58.7265 49.5454 111.378 39.0547C113.131 38.7054 111.477 39.678 107.523 42.0034C92.2931 50.9599 42.9371 79.9855 22.6806 130.848Z'
      fill='url(#paint0_linear_551_2299)'
      fillOpacity='0.5'
    />
    <path
      d='M64.5022 85.0161C62.7826 85.6691 61.0266 86.2226 59.2431 86.674C56.8871 87.2463 55.5569 87.5116 53.283 86.6319C53.2031 86.601 53.1269 86.5705 53.055 86.5404C48.7449 84.7137 45.0605 81.6773 42.4503 77.801C39.84 73.9247 38.4166 69.3756 38.3532 64.7074C38.3418 64.5473 38.3418 64.3789 38.3418 64.2146C38.3396 63.4235 38.3775 62.6327 38.4555 61.8453C38.5551 60.7728 38.7272 59.7083 38.9706 58.6589L38.9479 58.6548C37.1069 56.7782 36.3985 54.2077 36.6333 51.6248C36.7942 49.8738 37.3518 48.182 38.2638 46.6769C39.1759 45.1718 40.4188 43.8927 41.8989 42.936C44.2184 41.4823 46.8337 40.5621 49.5547 40.2423C50.2854 40.1583 51.0202 40.1158 51.7557 40.115H58.6652C60.0923 39.7819 61.5421 39.5541 63.0027 39.4333H63.014C76.9204 38.2836 87.8871 47.4734 86.8643 58.6547C86.8567 58.6671 86.8454 58.6794 86.8378 58.6917C86.5423 59.1721 86.2809 59.6279 86.0498 60.0632C85.8263 60.4697 85.6369 60.8598 85.474 61.2294C84.205 64.0873 90.2358 108.429 88.0727 109.102C86.8415 109.484 81.8791 76.4883 82.7693 82.7627C83.8906 90.6343 70.9087 82.6554 64.5022 85.0161Z'
      fill='#2F2E41'
    />
    <path
      d='M85.4511 165.172L104.728 206.108L30.5742 198.622L46.0534 159.323L85.4511 165.172Z'
      fill='#FFB6B6'
    />
    <path
      d='M124.148 247.248C111.254 251.527 97.6644 253.341 84.0945 252.596L78.1936 243.057C78.1936 243.057 77.9465 246.61 77.578 252.041C71.1183 251.295 64.7429 249.947 58.5352 248.017C46.7628 244.347 35.7274 238.661 24.5413 233.418C22.2756 219.955 21.4254 199.194 33.9517 187.108L101.374 199.424C101.374 199.424 112.192 207.489 109.298 210.378C106.404 213.263 105.956 212.816 107.857 214.711C109.758 216.607 113.867 219.141 113.909 220.798C113.926 221.445 118.537 233.18 124.148 247.248Z'
      fill='#2F2E41'
    />
    <path
      d='M73.6773 86.0674L57.3883 87.2002L46.86 97.3414L43.1728 97.9974C39.8585 98.5865 36.8762 100.367 34.7915 103.002C32.7068 105.638 31.6647 108.944 31.8627 112.294C32.6211 125.103 34.3193 144.241 37.8686 150.451C43.3721 160.079 47.9179 157.058 43.3721 160.079C38.8263 163.1 35.7744 160.726 37.8686 165.5C39.9628 170.274 35.0382 176.398 35.0382 176.398L33.0778 178.352L35.157 179.202L101.409 187.795C101.409 187.795 95.6808 162.12 99.2635 155.813C102.846 149.506 111.533 130.441 103.78 122.981L96.1998 96.3907L83.161 92.5574L73.6773 86.0674Z'
      fill='url(#paint1_linear_551_2299)'
    />
    <path
      d='M172.284 191.445C171.193 191.41 170.124 191.14 169.149 190.653C168.174 190.166 167.316 189.474 166.636 188.624C165.956 187.774 165.469 186.787 165.209 185.731C164.949 184.675 164.922 183.576 165.13 182.509L134.053 161.529L137.761 151.533L174.489 176.72C176.265 177.204 177.802 178.319 178.808 179.856C179.814 181.393 180.219 183.244 179.947 185.059C179.675 186.874 178.745 188.527 177.333 189.704C175.92 190.88 174.124 191.5 172.284 191.445V191.445Z'
      fill='#D8B8AB'
    />
    <path
      d='M84.5042 95.1348L79.9883 96.9172L104.078 143.817L153.949 177.702L161.137 165.591L123.175 132.905L107.977 103.85C105.838 99.7616 102.255 96.6077 97.9203 94.998C93.5851 93.3884 88.8054 93.4371 84.5042 95.1348Z'
      fill='url(#paint2_linear_551_2299)'
    />
    <path
      d='M64.6856 81.9429C73.7191 81.9429 81.0422 74.6431 81.0422 65.6384C81.0422 56.6337 73.7191 49.334 64.6856 49.334C55.6522 49.334 48.3291 56.6337 48.3291 65.6384C48.3291 74.6431 55.6522 81.9429 64.6856 81.9429Z'
      fill='#D8B8AB'
    />
    <path
      d='M78.9093 58.7435C78.6366 58.8869 78.3676 59.0191 78.0948 59.1513C77.8107 59.2872 77.5266 59.4232 77.2387 59.5515C71.7648 62.0249 67.3062 62.3005 64.6014 58.7435C64.5274 56.8721 64.1048 55.0307 63.3551 53.3134C63.4876 55.2325 62.9802 57.1415 61.9118 58.7435H56.4645C50.8542 62.4553 47.9752 65.8652 51.8694 78.0506C52.1232 78.8512 53.862 107.293 54.3582 109.479C45.8652 106.232 38.5389 71.7521 38.3533 62.6668C38.3419 62.5196 38.3419 62.3647 38.3419 62.2137C38.3397 61.4859 38.3777 60.7585 38.4556 60.0349C38.5555 59.0469 38.7277 58.0676 38.9708 57.1046L38.948 57.1008C38.0839 56.2773 37.4247 55.264 37.0228 54.1417C36.621 53.0194 36.4877 51.819 36.6335 50.6362C38.0582 48.7766 39.8214 47.201 41.8308 45.9916C43.658 45.1096 45.5626 44.3967 47.5206 43.8619C47.5699 43.8505 47.6115 43.8392 47.6608 43.8279C48.2593 43.6655 48.873 43.5183 49.4867 43.3899C50.7513 43.1255 52.03 42.9326 53.3165 42.8121C53.4112 42.8083 53.5021 42.8008 53.5855 42.8008C54.1001 42.8011 54.6051 42.9394 55.0477 43.201C55.0515 43.201 55.0515 43.2048 55.059 43.2048C55.4843 43.4581 55.837 43.8163 56.0831 44.2449C56.3293 44.6734 56.4606 45.1579 56.4645 45.6517H62.5331C62.7566 45.6517 62.9801 45.6593 63.2036 45.6706C71.655 46.0067 78.4472 49.6091 78.8828 57.8901C78.9017 58.177 78.9093 58.4565 78.9093 58.7435Z'
      fill='#2F2E41'
    />
    <path
      d='M43.0307 59.3989C48.9819 59.3989 53.8064 54.5898 53.8064 48.6575C53.8064 42.7251 48.9819 37.916 43.0307 37.916C37.0794 37.916 32.2549 42.7251 32.2549 48.6575C32.2549 54.5898 37.0794 59.3989 43.0307 59.3989Z'
      fill='#2F2E41'
    />
    <path
      d='M57.8241 43.6893C56.5999 49.4948 50.56 52.967 44.7818 51.5466C42.007 50.8646 39.6177 49.1116 38.1394 46.6735C36.6612 44.2354 36.2151 41.3118 36.8994 38.5458C38.3242 32.786 45.3368 34.4465 49.9417 30.6885C56.4559 25.3723 59.4751 35.8602 57.8241 43.6893Z'
      fill='#2F2E41'
    />
    <path
      d='M33.8818 205.292C43.0658 167.959 61.263 135.87 91.4 110.73C92.5663 108.817 94.4462 107.444 96.627 106.911C98.8079 106.378 101.112 106.729 103.033 107.888L174.676 151.188C176.595 152.351 177.973 154.225 178.507 156.399C179.042 158.573 178.689 160.869 177.527 162.784C166.024 201.092 148.796 234.333 120.009 257.346C118.843 259.259 116.963 260.632 114.782 261.165C112.601 261.698 110.298 261.347 108.376 260.188L36.7329 216.888C34.8142 215.725 33.4365 213.851 32.902 211.677C32.3675 209.503 32.7198 207.207 33.8818 205.292Z'
      fill='#F2F2F2'
    />
    <path
      opacity='0.2'
      d='M46.6157 217.873C44.697 216.711 43.3192 214.837 42.7848 212.663C42.2503 210.489 42.6027 208.193 43.7647 206.277C52.9486 168.944 71.1459 136.856 101.283 111.715C102.055 110.463 103.145 109.437 104.443 108.74L103.033 107.888C101.112 106.729 98.8078 106.378 96.627 106.911C94.4461 107.444 92.5663 108.817 91.3999 110.729C61.263 135.87 43.0658 167.958 33.8819 205.291C32.7199 207.207 32.3675 209.503 32.9019 211.677C33.4364 213.851 34.8142 215.725 36.7329 216.887L108.376 260.188C109.651 260.953 111.106 261.368 112.594 261.392C114.082 261.415 115.55 261.046 116.849 260.322L46.6157 217.873Z'
      fill='#3D503D'
    />
    <path
      d='M130.636 197.015L82.5454 168.131C81.7814 167.671 81.2319 166.928 81.0175 166.064C80.8032 165.2 80.9415 164.287 81.4022 163.524C81.8629 162.762 82.6083 162.213 83.4746 161.999C84.3409 161.784 85.2573 161.921 86.0225 162.379L134.113 191.263C134.875 191.724 135.423 192.467 135.636 193.33C135.849 194.193 135.71 195.105 135.25 195.867C134.79 196.628 134.046 197.176 133.181 197.391C132.316 197.607 131.401 197.472 130.636 197.015L130.636 197.015Z'
      fill='white'
    />
    <path
      d='M102.66 158.712L92.0797 152.358C91.313 151.901 90.7599 151.159 90.5421 150.295C90.3243 149.431 90.4596 148.517 90.9183 147.752C91.377 146.988 92.1214 146.437 92.9879 146.219C93.8544 146.002 94.7719 146.137 95.5387 146.594L95.5569 146.605L106.137 152.96C106.899 153.421 107.447 154.164 107.66 155.027C107.874 155.891 107.735 156.803 107.275 157.564C106.815 158.325 106.07 158.874 105.205 159.089C104.34 159.304 103.425 159.169 102.66 158.712Z'
      fill='white'
    />
    <path
      d='M122.993 209.66L74.9023 180.776C74.1374 180.317 73.5867 179.573 73.3711 178.71C73.1556 177.846 73.2928 176.932 73.7527 176.169C74.2126 175.407 74.9575 174.857 75.8238 174.641C76.6901 174.425 77.6068 174.561 78.3726 175.019L78.3794 175.023L126.47 203.907C127.232 204.368 127.78 205.112 127.993 205.975C128.206 206.838 128.067 207.75 127.607 208.511C127.147 209.272 126.403 209.82 125.538 210.036C124.673 210.251 123.758 210.116 122.993 209.66L122.993 209.66Z'
      fill='white'
    />
    <path
      d='M136.742 142.554C144.5 142.554 150.789 136.285 150.789 128.552C150.789 120.819 144.5 114.551 136.742 114.551C128.985 114.551 122.696 120.819 122.696 128.552C122.696 136.285 128.985 142.554 136.742 142.554Z'
      fill='#ADC8B6'
    />
    <path
      d='M112.53 278.583C129.111 278.583 142.552 265.184 142.552 248.657C142.552 232.129 129.111 218.73 112.53 218.73C95.9499 218.73 82.5088 232.129 82.5088 248.657C82.5088 265.184 95.9499 278.583 112.53 278.583Z'
      fill='white'
    />
    <path
      d='M112.53 278.999C106.51 278.999 100.624 277.22 95.6185 273.886C90.6126 270.552 86.711 265.813 84.407 260.268C82.103 254.723 81.5002 248.622 82.6747 242.736C83.8493 236.85 86.7484 231.444 91.0056 227.2C95.2627 222.956 100.687 220.066 106.592 218.896C112.496 217.725 118.617 218.326 124.179 220.622C129.741 222.919 134.496 226.808 137.841 231.798C141.185 236.788 142.971 242.654 142.971 248.656C142.962 256.701 139.752 264.413 134.045 270.102C128.338 275.791 120.601 278.99 112.53 278.999ZM112.53 219.147C106.675 219.147 100.952 220.878 96.0838 224.121C91.2157 227.363 87.4214 231.972 85.1808 237.364C82.9402 242.756 82.354 248.689 83.4963 254.413C84.6385 260.137 87.4579 265.395 91.598 269.522C95.738 273.649 101.013 276.459 106.755 277.598C112.498 278.736 118.45 278.152 123.859 275.918C129.268 273.685 133.891 269.903 137.144 265.05C140.397 260.197 142.133 254.492 142.133 248.656C142.124 240.832 139.003 233.332 133.453 227.8C127.903 222.268 120.379 219.156 112.53 219.147Z'
      fill='#F39C12'
    />
    <path
      d='M108.435 264.232C107.916 264.232 107.405 264.111 106.941 263.88C106.477 263.649 106.074 263.313 105.763 262.9L97.5729 252.014C97.3093 251.664 97.1175 251.266 97.0083 250.843C96.8992 250.419 96.8748 249.978 96.9367 249.545C96.9986 249.112 97.1454 248.696 97.3689 248.319C97.5924 247.943 97.8881 247.614 98.2392 247.352C98.5902 247.089 98.9897 246.898 99.4147 246.79C99.8398 246.681 100.282 246.657 100.717 246.72C101.151 246.782 101.569 246.928 101.946 247.151C102.324 247.375 102.653 247.67 102.916 248.02L108.274 255.141L122.037 234.563C122.28 234.2 122.593 233.887 122.957 233.644C123.322 233.401 123.731 233.231 124.161 233.146C124.591 233.06 125.033 233.06 125.464 233.144C125.894 233.229 126.303 233.398 126.668 233.64C127.033 233.883 127.346 234.194 127.59 234.558C127.834 234.921 128.004 235.328 128.09 235.757C128.176 236.186 128.177 236.627 128.092 237.056C128.007 237.485 127.837 237.893 127.594 238.257L111.214 262.749C110.917 263.192 110.519 263.558 110.051 263.816C109.584 264.073 109.061 264.216 108.528 264.231C108.497 264.231 108.466 264.232 108.435 264.232Z'
      fill='#F39C12'
    />
    <path
      d='M209.485 97.005C210.678 96.9034 211.588 96.1503 211.517 95.323C211.446 94.4958 210.421 93.9076 209.228 94.0093C208.035 94.1109 207.126 94.864 207.197 95.6912C207.268 96.5185 208.292 97.1067 209.485 97.005Z'
      fill='white'
    />
    <path
      d='M222.908 92.466C224.101 92.3643 225.011 91.6112 224.94 90.784C224.869 89.9567 223.844 89.3685 222.651 89.4702C221.458 89.5719 220.549 90.3249 220.62 91.1522C220.691 91.9794 221.715 92.5676 222.908 92.466Z'
      fill='#455C45'
    />
    <path
      d='M203.123 86.797C204.316 86.6953 205.226 85.9423 205.155 85.115C205.084 84.2878 204.059 83.6996 202.866 83.8012C201.673 83.9029 200.764 84.656 200.835 85.4832C200.906 86.3105 201.93 86.8987 203.123 86.797Z'
      fill='#F39C12'
    />
    <path
      d='M197.493 83.5077C198.006 83.3921 198.287 82.7019 198.12 81.9661C197.954 81.2304 197.402 80.7277 196.889 80.8433C196.375 80.959 196.094 81.6492 196.261 82.3849C196.428 83.1207 196.979 83.6234 197.493 83.5077Z'
      fill='#E6E6E6'
    />
    <path
      d='M193.484 75.5224C193.997 75.4067 194.278 74.7165 194.112 73.9808C193.945 73.245 193.393 72.7423 192.88 72.858C192.366 72.9736 192.085 73.6638 192.252 74.3996C192.419 75.1353 192.97 75.638 193.484 75.5224Z'
      fill='#455C45'
    />
    <path
      d='M212.717 86.7362C213.231 86.6206 213.512 85.9304 213.345 85.1946C213.178 84.4589 212.627 83.9562 212.113 84.0719C211.6 84.1875 211.319 84.8777 211.486 85.6134C211.652 86.3492 212.204 86.8519 212.717 86.7362Z'
      fill='#E6E6E6'
    />
    <path
      d='M206.854 91.5878C207.367 91.4722 207.648 90.782 207.482 90.0462C207.315 89.3105 206.764 88.8078 206.25 88.9234C205.737 89.0391 205.456 89.7293 205.622 90.465C205.789 91.2008 206.341 91.7035 206.854 91.5878Z'
      fill='#F39C12'
    />
    <path
      d='M217.528 95.539C218.041 95.4233 218.322 94.7331 218.156 93.9974C217.989 93.2616 217.437 92.7589 216.924 92.8746C216.41 92.9902 216.129 93.6804 216.296 94.4162C216.463 95.1519 217.014 95.6546 217.528 95.539Z'
      fill='#455C45'
    />
    <path
      d='M154.068 35.1474C154.272 34.3426 153.497 33.4525 152.337 33.1593C151.176 32.8661 150.069 33.2809 149.865 34.0857C149.66 34.8905 150.435 35.7807 151.596 36.0738C152.756 36.367 153.863 35.9523 154.068 35.1474Z'
      fill='white'
    />
    <path
      d='M139.894 35.0566C140.098 34.2518 139.323 33.3616 138.163 33.0684C137.002 32.7752 135.895 33.19 135.691 33.9948C135.486 34.7997 136.261 35.6898 137.422 35.983C138.582 36.2762 139.689 35.8614 139.894 35.0566Z'
      fill='#455C45'
    />
    <path
      d='M156.728 46.8691C156.932 46.0643 156.157 45.1742 154.997 44.881C153.836 44.5878 152.729 45.0025 152.525 45.8074C152.32 46.6122 153.095 47.5023 154.256 47.7955C155.416 48.0887 156.523 47.674 156.728 46.8691Z'
      fill='#F39C12'
    />
    <path
      d='M160.032 51.2892C160.116 50.5396 159.76 49.8847 159.237 49.8264C158.714 49.7681 158.222 50.3286 158.138 51.0782C158.053 51.8278 158.409 52.4828 158.933 52.5411C159.456 52.5993 159.948 52.0389 160.032 51.2892Z'
      fill='#E6E6E6'
    />
    <path
      d='M161.197 60.1427C161.281 59.3931 160.925 58.7382 160.402 58.6799C159.879 58.6216 159.387 59.1821 159.303 59.9317C159.219 60.6814 159.574 61.3363 160.098 61.3946C160.621 61.4528 161.113 60.8924 161.197 60.1427Z'
      fill='#455C45'
    />
    <path
      d='M146.707 43.2707C146.791 42.521 146.435 41.8661 145.912 41.8078C145.389 41.7496 144.896 42.31 144.812 43.0597C144.728 43.8093 145.084 44.4642 145.607 44.5225C146.131 44.5808 146.623 44.0203 146.707 43.2707Z'
      fill='#E6E6E6'
    />
    <path
      d='M153.84 40.5998C153.924 39.8501 153.568 39.1952 153.045 39.1369C152.521 39.0787 152.029 39.6391 151.945 40.3888C151.861 41.1384 152.217 41.7933 152.74 41.8516C153.263 41.9099 153.756 41.3494 153.84 40.5998Z'
      fill='#F39C12'
    />
    <path
      d='M145.053 33.383C145.137 32.6333 144.781 31.9784 144.257 31.9201C143.734 31.8619 143.242 32.4223 143.158 33.172C143.074 33.9216 143.43 34.5765 143.953 34.6348C144.476 34.6931 144.969 34.1326 145.053 33.383Z'
      fill='#455C45'
    />
    <path
      d='M38.3493 205.687C37.2789 205.249 36.3164 204.586 35.5286 203.741C34.7408 202.897 34.1465 201.892 33.7866 200.796C33.4268 199.7 33.31 198.539 33.4445 197.394C33.579 196.248 33.9614 195.146 34.5654 194.162L11.4873 161.825L18.8909 153.263L46.0194 191.87C47.6046 193.006 48.7164 194.683 49.1443 196.582C49.5722 198.481 49.2863 200.471 48.3409 202.174C47.3955 203.877 45.8562 205.175 44.0146 205.823C42.1731 206.47 40.1574 206.422 38.3493 205.687H38.3493Z'
      fill='#D8B8AB'
    />
    <path
      d='M38.8799 103.211C37.7123 102.526 36.3382 102.279 35.004 102.513C33.6699 102.747 32.4632 103.447 31.6004 104.488L0.418945 147.959L29.3161 188.87L40.6236 176.764L23.0341 149.211L46.4107 127.025C48.3317 122.83 48.6252 118.074 47.2343 113.676C45.8435 109.278 42.867 105.549 38.8799 103.211Z'
      fill='url(#paint3_linear_551_2299)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_551_2299'
        x1='210.977'
        y1='-46.6276'
        x2='297.488'
        y2='234.985'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C1BDB4' />
        <stop offset='0.396113' stopColor='#DED6C7' />
        <stop offset='1' stopColor='#F5F3EE' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_551_2299'
        x1='31.8883'
        y1='187.829'
        x2='6.71322'
        y2='-120.423'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2C3B38' />
        <stop offset='1' stopColor='#ADC8B6' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_551_2299'
        x1='80.0417'
        y1='177.73'
        x2='64.1661'
        y2='-77.1374'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2C3B38' />
        <stop offset='1' stopColor='#ADC8B6' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_551_2299'
        x1='0.450335'
        y1='188.9'
        x2='-28.0191'
        y2='-71.6763'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2C3B38' />
        <stop offset='1' stopColor='#ADC8B6' />
      </linearGradient>
    </defs>
  </svg>
);

export const UndrawCertificationIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UndrawCertificationSvg} {...props} />
);
